import Button from '@mui/material/Button';

import PonduranceSvgIcon from '@/components/PonduranceSvgIcon';
import {
  DOCS_URL,
  LOGSCALE_URL,
  MYCYBERSCORECARD_URL,
  PONDURANCE_NAME,
  SCOPE_URL,
  TICKET_URL
} from '@/constants/common';

import type { PonduranceLinkButtonProps } from './PonduranceLinkButton.types';

const PonduranceLinkButton = (props: PonduranceLinkButtonProps) => {
  const { url } = props;

  const getLabel = () => {
    // Pondurance Docs
    if ((url as string).includes(DOCS_URL)) {
      return 'Pondurance Docs';
    }
    // Pondurance Logscale
    if ((url as string).includes(LOGSCALE_URL)) {
      return 'Pondurance Logs';
    }
    // Pondurance Scope Ticket
    if ((url as string).includes(TICKET_URL)) {
      return 'Pondurance Ticket';
    }
    // Pondurance Scope
    if ((url as string).includes(SCOPE_URL)) {
      return 'Pondurance Scope';
    }
    // Pondurance MyCyberScoreCard
    if ((url as string).includes(MYCYBERSCORECARD_URL)) {
      return 'Pondurance MyCyberScoreCard';
    }
    // Pondurance
    return PONDURANCE_NAME;
  };

  return (
    <Button
      href={url as string}
      rel="noopener noreferrer"
      startIcon={<PonduranceSvgIcon />}
      size="small"
      sx={{ margin: '0.20rem 0' }}
      target="_blank"
      variant="outlined"
    >
      {getLabel()}
    </Button>
  );
};

export default PonduranceLinkButton;
